import { LoadingManager } from 'three';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { GLTF, GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

export class ThreeService {
  private readonly loader: GLTFLoader;
  private readonly decompressor: DRACOLoader;

  constructor() {
    const manager = new LoadingManager();

    const decompressor = new DRACOLoader(manager);
    decompressor.setDecoderPath('/draco_v0.157.0/');
    decompressor.setDecoderConfig({ type: 'js' });

    const loader = new GLTFLoader(manager);
    loader.setDRACOLoader(decompressor);

    this.loader = loader;
    this.decompressor = decompressor;
  }

  async load(buffer: ArrayBuffer): Promise<GLTF> {
    const result = await this.loader.parseAsync(buffer, 'file.glb');
    this.decompressor.dispose();
    return result;
  }
}
